import React from "react"; 

const Birthday = () => {
    return(
        <>
            <marquee scrollamount="2" scrolldelay="30" direction="up" align="left" onmouseover="stop();" onmouseout="start();" >       
                <div className="birthday-blk">
                    <div className="img">
                        <img src="/Images/birthday1.png" />
                    </div>
                    <div className="content">
                        <h3>Akshay Kumar Sharma</h3> 
                        <p class="primary">VIII-B</p>
                    </div>
                </div>
                <div className="birthday-blk">
                    <div className="img">
                        <img src="/Images/birthday2.png" />
                    </div>
                    <div className="content">
                        <h3>Akansha Shriwastav</h3> 
                        <p class="primary">VII-B</p>
                    </div>
                </div>
                <div className="birthday-blk">
                    <div className="img">
                        <img src="/Images/birthday3.png" />
                    </div>
                    <div className="content">
                        <h3>Sushmita Kumari</h3>
                        <p class="primary">VI-A</p>
                    </div>
                </div> 
                <div className="birthday-blk">
                    <div className="img">
                        <img src="/Images/birthday4.png" />
                    </div>
                    <div className="content">
                        <h3>Pragati Singh</h3>
                        <p class="primary">VI-A</p>
                    </div>
                </div>
            </marquee>
        </>
    )
}
export default Birthday